module.exports = __webpack_public_path__ + "img/math.1d31736c.png";